import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
/**
 * Service permettant de stocker pour tous les composants le contexte en cours sur la session (commerçant ciblé, point de vente ciblé, etc)
 */
export class ContextAppService {
  //TODO voir pour l'utiliser le + possible partout, car une fois que l'on a récupéré les méta, le point de vente est fixe jusqu'a un prochain appel URL différent
  public currentPointOfSale = null
  public webshopId :string | null = null

  constructor() { }
}
